function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  id: "Ellipse_46",
  "data-name": "Ellipse 46",
  cx: 3.009,
  cy: 3.009,
  r: 3.009,
  transform: "translate(1.686)",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Subtraction_1",
  "data-name": "Subtraction 1",
  d: "M22852.428-11891.718c-.467,0-1.029,0-1.662-.009-.961-.008-2.105-.017-3.523-.017a1.212,1.212,0,0,1-1.211-1.211c0-.369-.008-.73-.016-1.049-.043-2-.08-3.719,1.543-5.021a4.5,4.5,0,0,1,3.061-.977c.273,0,.568.014.9.041a3.048,3.048,0,0,1,.988.174.976.976,0,0,0-.529.595.977.977,0,0,0,.242,1l1.445,1.423-.332,2a.984.984,0,0,0,.395.958,1,1,0,0,0,.58.189,1.051,1.051,0,0,0,.453-.109l.607-.315c0,1.32,0,1.33-.107,1.567C22854.973-11891.822,22854.758-11891.718,22852.428-11891.718Z",
  transform: "translate(-22846.002 11907.168)",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_317",
  "data-name": "Path 317",
  d: "M128.183,123.546a.462.462,0,0,0,.116.473l1.556,1.532L129.5,127.7a.463.463,0,0,0,.67.487l1.937-1.006,1.937,1.006a.463.463,0,0,0,.67-.487l-.358-2.153,1.556-1.532a.463.463,0,0,0-.255-.787l-2.159-.325-.976-1.953a.482.482,0,0,0-.828,0l-.976,1.953-2.159.325a.463.463,0,0,0-.371.315Z",
  transform: "translate(-121.543 -115.369)",
  fill: "#fff"
});

var SvgEkspertspil = function SvgEkspertspil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Component_28_1",
    "data-name": "Component 28 \\u2013 1",
    width: 14.504,
    height: 15.45,
    viewBox: "0 0 14.504 15.45",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEkspertspil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ekspertspil.bb037fd6.svg";
export { ForwardRef as ReactComponent };